<template>
    <div class="comparison-content">
      <!-- comparison -->
      <div style="position: fixed;right: 2vw;top: 45vh;z-index: 9999;background-color: white;height: 5vh;">
          <!-- Back -->
        <img @click="$router.go(-1)" style="height: 5vh;" src="@/assets/btn/close.png" alt="">
      </div>
      <div class="comparison-data">
        <!-- unit img left -->
        <div v-if="!leftCompareType" class="comparison-data-right-table">
          <div class="table-data-cmp">
            <div class="table-tr" v-for="(data, tr) in BuildingData" :key="tr" :class="{mergetr:data.length ==2}">
              <div class="table-td-unit" :style="`background:${tddata.color};`" 
              :class="{'td-tab':td==0,
              'td-tab-top': td != 0 && tr == 0, 
              mergetd:td==1&&data.length ==2}"  
              @click="SetUnit('left',tddata.unitname)"
              v-for="(tddata, td) in data" :key="td" >
              <span v-if="tr !=0 && td == 0">{{ tddata.name }}</span>
              <span v-else-if="tr == 0 && td != 0">{{ tddata.name }}</span>
              <span v-else-if="tr == 0 && td == 0">{{ tddata.name }}</span>
              <span v-else >{{ tddata.name }}</span>
              </div>
            </div>
          </div>
          <div class="BuildingList flex-contents" style="position: absolute;bottom: 10px;">
            <div class="BuildingListBtn" style="font-size: 12px;"
            @click="SwitchBuilding(item,i)"
            v-if="i!='OVERALL'"
            :class="{'checkedBuildingBtn':BuildingName == i}" v-for="(item,i) in BuildingList" :key="i">{{i}}</div>
          </div>
        </div>
        <div v-else style="width: 100%;height: 100%;">
        <!-- <div class="comparison-unit-info">
          <h2 style="margin:0px">SHOW UNIT</h2>
          <h4>{{ leftCompareUnit.Name }}</h4>
          <h4>{{ leftCompareUnit.type }}</h4>
          <div class="line-css"></div>
          <p>{{ leftCompareUnit.size }}</p>
        </div> -->
        <motion :zoomsize="1" index="1" ref="motions">
          <img style="max-width: 100%;max-height: 100%;margin: auto;" ondragstart="return false;" :src="leftCompareUnit.plan" alt="">
        </motion>
        <div @click="leftCompareType = false" class="building-btn">
            Building
          </div>
      </div>
      </div>
      <div class="comparison-data">
        <!-- table -->
        <div v-if="!rightCompareType" class="comparison-data-right-table">
          <div class="table-data-cmp">
            <div class="table-tr" v-for="(data, tr) in BuildingData" :key="tr" :class="{mergetr:data.length ==2}">
              <div class="table-td-unit" :style="`background:${tddata.color};`" 
              :class="{'td-tab':td==0,
              'td-tab-top': td != 0 && tr == 0, 
              mergetd:td==1&&data.length ==2}"  
              @click="SetUnit('right',tddata.unitname)"
              v-for="(tddata, td) in data" :key="td" >
              <span v-if="tr !=0 && td == 0">{{ tddata.name }}</span>
              <span v-else-if="tr == 0 && td != 0">{{ tddata.name }}</span>
              <span v-else-if="tr == 0 && td == 0">{{ tddata.name }}</span>
              <span v-else >{{ tddata.name }}</span>

              </div>
            </div>
          </div>
          <div class="BuildingList flex-contents" style="position: absolute;bottom: 10px;">
            <div class="BuildingListBtn" style="font-size: 12px;"
            @click="SwitchBuilding(item,i)"
            v-if="i!='OVERALL'"
            :class="{'checkedBuildingBtn':BuildingName == i}" v-for="(item,i) in BuildingList" :key="i">{{i}}</div>
          </div>
        </div>
        <div v-else style="width: 100%;height: 100%;">
          <!-- <div style="position: absolute;right: 20px;top: 20%;z-index: 999;">SHOW UNIT</div> -->
          <!-- <div class="comparison-unit-info">
            <h2 style="margin:0px">SHOW UNIT</h2>
            <h4>{{ rightCompareUnit.Name }}</h4>
            <h4>{{ rightCompareUnit.type }}</h4>
            <div class="line-css"></div>
            <p>{{ rightCompareUnit.size }}</p>
          </div> -->
          <motion :zoomsize="1" index="2" ref="motions">
            <img style="max-width: 100%;max-height: 100%;margin: auto;" ondragstart="return false;" :src="rightCompareUnit.plan" alt="">
          </motion>
          <div @click="rightCompareType = false" class="building-btn">
            Building
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import motion from "@/components/motion.vue"
export default {
  components:{motion},
  data() {
    return {
      leftCompareUnit:{},
      rightCompareUnit:{},
      leftCompareType:false,
      rightCompareType:false,
      BuildingName:"BLOCK 38",
      BuildingData:{},
      BuildingList:{},

    }
  },
  mounted(){
    console.log(this.$route.query);
    this.BuildingList = this.$Datas.building
    this.BuildingData = this.BuildingList[this.BuildingName].buildingData
    this.leftCompareUnit = this.$Datas.floorplan[this.$route.query.unitname]
    if(this.leftCompareUnit){
      this.leftCompareType = true
    }

  },
  methods:{
    SetUnit(About,floorName){
      var Unit = this.$Datas.floorplan[floorName]
      if(About == 'left'){
        this.leftCompareUnit = Unit
        this.leftCompareType = true
      }else{
        this.rightCompareUnit = Unit
        this.rightCompareType = true

      }

    },
    SwitchBuilding(buildingdata,buildingName){
      this.BuildingName = buildingName
      this.BuildingData = buildingdata.buildingData
    },
  }
}
</script>


<style lang="less">

.comparison-unit-info{
  position: absolute;
  z-index: 999;
  padding: 10px;
  bottom: 5px;
  left: 5px;
  text-align: start;
  background-color: white;
  border: 1px solid black;
  border-radius: 5px;
  .line-css{
    background-color: #000000;
    height: 1px;
    margin: 2px 0px;
  }
  h4{
    margin: 0;
    line-height: 24px;
  }
  p{
    margin: 0;
    line-height: 20px;
  }
}
.comparison-content{
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 1300;
  width: 100%;
  height: 90%;
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.comparison-btn{
  // font-weight: bold;
  // background-color: white;
  // color: black;
  // padding: 10px;
  // width: 100px;
  // border-radius: 10px;
  // text-align: center;
  margin-top: 30px;
  margin-left: 15px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
}

.comparison-data{
  width: 50%;
  height: 100%;
  border: 1px solid black;
  position: relative;
  .comparison-data-right-table{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}



.BuildingList{
  font-family: 'AzoSans-Bold';
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  // height: 10%;
  .BuildingListBtn{
    height: 35px;
    line-height: 35px;
    // margin: 0 10px;
    padding: 0 10px;
    background-color: black;
    border:1px solid #ffffff;
    color: white;
    cursor: pointer;
  }
}

.mergetr{
  position: relative;
  width: 100%;
}
.mergetd{
  // position: absolute;
  width: calc(100% - 88px) !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  border: 0 !important;
  border-bottom: 2px solid #000000 !important;
}
.building-btn{
  position: absolute;
  bottom: 10px;
  right: 20px;
  background-color: black;
  color: white;
  padding: 10px;
  cursor: pointer;
}
.table-data-cmp{
  border-collapse: collapse;
  border-spacing: 0;
  // border: 1px solid #eab7a2;
  font-family: QuicksandBook;
  // width: 99%;
  // color: #000;
  // margin-top: 3rem;
  // margin-bottom: 2.5rem;
  display: table;
}
.table-tr{
// border: 0px solid #9E9E9E;
display: flex;
flex-direction: row;
// width: 99%;
}
.td-tab{
  // width: 1.5rem !important;
  // border: 0 !important;
  border: 2px solid #ffffff00 !important;
  font-weight: 600 !important;
  // font-size: 14px !important;
  // background-color: #000 !important;
}
.td-tab-top{
  font-weight: 600 !important;
  // font-size: 14px !important;
  border:  1px solid #000000 !important;
  background-color: white !important;
}
// .table-td-unit:hover{
//   color: #ffffff !important;
//   background-color: #000000 !important;
// }
.table-td-unit{
  cursor: pointer;
  // border-bottom: 1px solid #000000;
  font-size: 10px;
  font-weight: 400;
  text-align: center;
  // width: 2.5rem;
  width: 3vw;
  height: 2vh;
  // border: 1px solid #9E9E9E;
  border-width: 0 0 0 1px;
  margin: 0;
  overflow: visible;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-collapse: collapse;
  border: 1px solid #000000;
  margin: -1px;
}

.checkedBuildingBtn {
  // color: #2efffa !important;
  color: #000 !important;
  background-color: #00bcd4 !important;
}
@media screen and (max-height: 500px){

  .building-btn{
    padding: 5px;
  }
  .table-td-unit{
    font-size: 7px;
  }
  .table-data-cmp{
  border-collapse: collapse;
  border-spacing: 0;
  // border: 1px solid #eab7a2;
  font-family: QuicksandBook;
  // width: 99%;
  // color: #000;
  // margin-top: 3rem;
  // margin-bottom: 2.5rem;
  display: block !important;
  height: 80% !important;
  overflow: auto;
  } 
  .BuildingListBtn{
    height: 25px !important;
    line-height: 25px !important;
    font-size: 10px !important;
  }
  .comparison-unit-info{
    display: none !important;
  }
}

</style>









